import { Colors, Breakpoint, Location } from "../../interface/ThemeProvider";
import { useLocation } from "react-router-dom";

export const theme: { colors: Colors; mobile: Breakpoint; location: Location } = {
  colors: {
    primaryLight: "#3BAFBF",
    primaryDark: "#00A8BF",
    navmenuBg: "#1d3345",
    body: "#f8f9fa",
  },

  mobile: {
    mobile: "576px",
    tablet: "768px",
    desktop: "1024px",
  },

  location: {
    location: useLocation
  },
};
